/**
 * Central route definitions
 *
 * Use these instead of hardcoded strings throughout the app.
 * Makes refactoring easier and prevents typos.
 */

export const routes = {
  // Public routes
  login: "/login",
  register: "/register",
  forgotPassword: "/auth/forgot",
  recovery: "/auth/recovery",
  inviteAccept: "/invite/accept",
  resetPassword: "/auth/forgot",
  setPassword: "/auth/recovery",

  // My Area routes
  home: "/home",
  myAnimals: "/my/animals",
  myAnimalNew: "/my/animals/new",
  myAnimalBatch: "/my/animals/batch",
  myAnimal: (caseId: string) => `/my/animals/${caseId}` as const,
  /** Akte, Tab Pflege, Fokus auf der Eingabezeile. Kein Protokoll im Board. */
  myAnimalProtocol: (caseId: string) =>
    `/my/animals/${caseId}?tab=care&focus=entry` as const,
  myLocations: "/my/locations",
  myCareSites: "/my/care-sites",
  myCareSite: (siteId: string) => `/my/care-sites/${siteId}` as const,
  myMedicus: "/my/medicus",
  myClub: "/my/club",
  myClubNew: "/my/club/new",
  myClubItem: (itemId: string) => `/my/club/${itemId}` as const,
  myCalendar: "/my/calendar",
  myCalendarItem: (itemId: string) => `/my/calendar/${itemId}` as const,
  profile: "/my/profile",
  search: "/my/search",

  // Tenant routes (functions that take tenantId)
  tenant: {
    animals: (tenantId: string) => `/t/${tenantId}/animals` as const,
    animalNew: (tenantId: string) => `/t/${tenantId}/animals/new` as const,
    animalImport: (tenantId: string) => `/t/${tenantId}/animals/import` as const,
    animalDetail: (tenantId: string, animalId: string) =>
      `/t/${tenantId}/animals/${animalId}` as const,
    animalEdit: (tenantId: string, animalId: string) =>
      `/t/${tenantId}/animals/${animalId}/edit` as const,
    medication: (tenantId: string) => `/t/${tenantId}/medication` as const,
    members: (tenantId: string) => `/t/${tenantId}/members` as const,
    memberDetail: (tenantId: string, profileId: string) =>
      `/t/${tenantId}/members/${profileId}` as const,
    membersInvite: (tenantId: string) =>
      `/t/${tenantId}/members/invite` as const,
    settings: (tenantId: string) => `/t/${tenantId}/settings` as const,
  },
} as const;

/** Bottom-Bar und Drawer: Verein bleibt auch auf der Mitgliederverwaltung aktiv. */
export function isVereinAreaPath(pathname: string): boolean {
  if (pathname === "/my/club" || pathname.startsWith("/my/club/")) return true;
  return /^\/t\/[^/]+\/members(?:\/|$)/.test(pathname);
}
